<template>
  <div class="styled-keyword__container" :style="{ 'background-color': `${$attrs.color || 'rgb(57, 57, 57)'}` }">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.styled-keyword__container {
  font-family: "maplestory";

  width: fit-content;

  font-weight: 900;
  justify-content: center;
  align-items: center;

  padding: 0.4em 0.7em;
  border-radius: 0.5em;

  color: white;
  /* background-color: rgb(81, 81, 81); */
  /* background-color: #5932a3; */

  border: 0.1px solid rgb(213, 213, 213);
}
</style>
